import { SHARE_AT_CREATE_RIGHT, type RightsMap } from '@ehr/shared';
import { granted } from './myRights.js';
import { shareBody, type ShareDraft } from '../components/share/shareState.js';
import type { ShareBody } from './contactAccess.js';

/**
 * ehr#848: Add Client's "Add for myself & share" follows "Share a new contact at creation"
 * (Access Rights / Role Rights). With the right off the option is hidden and the API refuses a new
 * contact sent with a share. Unknown rights (still loading, or unreadable) count as off.
 */
export const shareAtCreateShown = (rights: RightsMap | null | undefined): boolean =>
  granted(rights, SHARE_AT_CREATE_RIGHT);

/**
 * The Share flow's picks as POST /contacts `share`: saved with the new contact in one request, so
 * the server checks the right and keeps the contact and its shares together (or neither).
 */
export function newContactShare(draft: ShareDraft): Omit<ShareBody, 'contactIds'> {
  const { contactIds: _ids, ...rest } = shareBody(draft, [], null);
  return rest;
}
